import PublicBookingForm from '@bookings/components/public-booking-form/public-booking-form.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'bpc-public-booking',
  components: {
    'bpc-public-booking-form': PublicBookingForm,
  },
})
export default class PublicBooking extends Vue {
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
